import { createReducer } from '@reduxjs/toolkit';
import { ActionObject } from '../StoreConstants';
import { Types } from './Actions';
import INITIAL_STATE, { SigninInitialState } from './InitialState';

const loginSuccess = (state: SigninInitialState, action: ActionObject) => ({
  ...state,
  user: action.payload,
});

const signOut = (state: SigninInitialState, action: ActionObject) => ({
  ...state,
  ...INITIAL_STATE,
});

export const SigninReducer = createReducer(INITIAL_STATE, {
  [Types.LOGIN]: loginSuccess,
  [Types.LOGOUT]: signOut,
});